import { XMarkIcon } from '@heroicons/react/20/solid';
import { InformationCircleIcon, CheckCircleIcon, ExclamationTriangleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';
import cn from './cn.js';

const tones = {
  info: { wrap: 'bg-sky-50 ring-sky-200 text-sky-900', icon: 'text-sky-500', Icon: InformationCircleIcon },
  brand: { wrap: 'bg-indigo-50 ring-indigo-200 text-indigo-900', icon: 'text-indigo-500', Icon: InformationCircleIcon },
  success: { wrap: 'bg-emerald-50 ring-emerald-200 text-emerald-900', icon: 'text-emerald-500', Icon: CheckCircleIcon },
  warning: { wrap: 'bg-amber-50 ring-amber-200 text-amber-900', icon: 'text-amber-500', Icon: ExclamationTriangleIcon },
  danger: { wrap: 'bg-red-50 ring-red-200 text-red-900', icon: 'text-red-500', Icon: ExclamationCircleIcon },
  neutral: { wrap: 'bg-gray-50 ring-gray-200 text-gray-800', icon: 'text-gray-400', Icon: InformationCircleIcon },
};

/** Inline message block. */
export default function Callout({ tone = 'info', title, children, icon, action, onDismiss, className, compact = false }) {
  const t = tones[tone] || tones.info;
  const Icon = icon || t.Icon;
  return (
    <div className={cn('flex gap-3 rounded-xl ring-1 ring-inset', t.wrap, compact ? 'px-3 py-2.5' : 'px-4 py-3.5', className)} role={tone === 'danger' ? 'alert' : 'status'}>
      <Icon className={cn('mt-0.5 h-5 w-5 shrink-0', t.icon)} aria-hidden="true" />
      <div className="min-w-0 flex-1 text-sm">
        {title && <p className="font-semibold">{title}</p>}
        {children && <div className={cn(title && 'mt-0.5', 'opacity-90')}>{children}</div>}
        {action && <div className="mt-2.5">{action}</div>}
      </div>
      {onDismiss && (
        <button type="button" onClick={onDismiss} className="-m-1 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md opacity-60 transition hover:bg-black/5 hover:opacity-100">
          <span className="sr-only">Dismiss</span>
          <XMarkIcon className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
